<mat-list dense twoLine interactive="false">
  <mat-list-item>
    <sn-icon mat-list-icon>vpn_key</sn-icon>
    <div mat-line>{{ incident.caseNumber }}</div>
    <div mat-line class="incidentDetailsMatLine">{{ 'common.caseNumber' | t }}</div>
  </mat-list-item>

  <mat-list-item>
    <sn-icon mat-list-icon>today</sn-icon>
    <div mat-line>{{ incident.createdTimestamp | fsFormatDate : 'medium' }}</div>
    <div mat-line class="incidentDetailsMatLine">{{ 'common.createdAt' | t }}</div>
  </mat-list-item>

  <mat-list-item *ngIf="incident.user">
    <sn-icon mat-list-icon>person</sn-icon>
    <div mat-line>{{ incident.user.fullName }}</div>
    <div mat-line class="incidentDetailsMatLine">{{ 'map.sentries.createdBy' | t }}</div>
  </mat-list-item>

  <mat-list-item *ngIf="incident.description">
    <sn-icon mat-list-icon>description</sn-icon>
    <div mat-line>{{ incident.description }}</div>
    <div mat-line class="incidentDetailsMatLine">{{ 'common.description' | t }}</div>
  </mat-list-item>

  <ng-container *ngIf="incident.geometry">
    <mat-list-item>
      <sn-icon mat-list-icon>place</sn-icon>
      <div mat-line>{{ incident.fullAddress }}</div>
      <div mat-line class="incidentDetailsMatLine">{{ 'common.address' | t }}</div>
    </mat-list-item>

    <mat-list-item>
      <sn-icon mat-list-icon>gps_fixed</sn-icon>
      <div mat-line>{{ incident.geometry | geometryToString }}</div>
      <div mat-line class="incidentDetailsMatLine">{{ 'common.coordinates' | t }}</div>
    </mat-list-item>
  </ng-container>
</mat-list>
